import { render, staticRenderFns } from "./StadiumUpdateForm.vue?vue&type=template&id=6f32957c&"
import script from "./StadiumUpdateForm.vue?vue&type=script&lang=js&"
export * from "./StadiumUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports